import { render, staticRenderFns } from "./FaqTopics.vue?vue&type=template&id=08a6cb80&scoped=true&"
import script from "./FaqTopics.vue?vue&type=script&lang=js&"
export * from "./FaqTopics.vue?vue&type=script&lang=js&"
import style0 from "./FaqTopics.vue?vue&type=style&index=0&id=08a6cb80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a6cb80",
  null
  
)

export default component.exports